import { ApiContract, HttpMethods } from '@tc/http';
import { Api } from '../../configuration/Api';
import { UserAccount } from '../../../features/account/models/UserAccount';

/**
 * Contract for creating a new user account.
 */
@ApiContract({ endpoint: Api.createAccount, httpMethod: HttpMethods.post })
export class ApiCreateAccount {
  constructor(account: UserAccount) {
    Object.assign(this, account);
  }
}
